import * as ActionTypes from './types.action';

export const submitInvoiceRegistration = (
  processId,
  customerEmail,
  customerMobile
) => ({
  type: ActionTypes.SUBMIT_INVOICE_REGISTRATION_REQUESTED,
  processId,
  customerEmail,
  customerMobile,
});

export const resetInvoiceRegistration = () => ({
  type: ActionTypes.SUBMIT_INVOICE_REGISTRATION_RESET,
});
